import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import { Form, Modal, CardWrapper } from "@components";
import React, { useCallback, useContext } from "react";
import { useHistory } from "react-router";
import { Actions } from "../../../../../../screens/request/components/actions";
import CloseIcon from "@material-ui/icons/Close";
import { Api } from "@api";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import convertToHtml from "draftjs-to-html";
import { convertToRaw, EditorState } from "draft-js";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { Feedback } from "../../../../../../store";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  id: 0;
  data: Feedback | undefined;
  isOpen: boolean;
  onClickAdd: () => void;
  onClickClose: () => void;
}

type FormValues = {
  id: number;
  feedbackId: string;
  feedbackType: string;
  status: string;
  dateTimeAdded: string;
  sentBy: string;
  feedbackSubject: string;
  businessUnit: string;
  details: string;
  screenshotURL: string;
  assignedTo: string;
  resolutionDetails: string;
  dateTimeClosed: string;
};

type Key = keyof FormValues;

export const FeedbackDetail: React.FC<Props> = ({
  id,
  data,
  isOpen,
  onClickAdd,
  onClickClose,
}) => {
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = React.useState<
    boolean
  >(false);
  const [pending, setPending] = React.useState(false);
  const initial_values = data;
  const [values, setValues] = React.useState<FormValues | undefined>(
    initial_values
  );
  const form = Form.useManager<FormValues>({
    id: 0,
    feedbackId: data ? data.feedbackId : "",
    feedbackType: data ? data.feedbackType : "",
    details: data ? data.details : "",
    status: data ? data.status : "",
    dateTimeAdded: data ? data.dateTimeAdded : "",
    sentBy: data ? data.sentBy : "",
    feedbackSubject: data ? data.feedbackSubject : "",
    businessUnit: data ? data.businessUnit : "",
    screenshotURL: data ? data.screenshotURL : "",
    assignedTo: data ? data.assignedTo : "",
    resolutionDetails: data ? data.resolutionDetails : "",
    dateTimeClosed: data ? data.dateTimeClosed : "",
  });

  function onChange(name: Key, value: any): void {
    console.log(value);
    form.set(Form.target.VALUE, [name, value]);
    validate([name, value]).then(([name, error]) => {
      form.set(Form.target.ERROR, [name, error]);
    });
  }

  function validate([name, value]: [string, any]): Promise<[Key, Error?]> {
    console.log(value);
    switch (name) {
      case "name":
        return Promise.resolve([name as Key, Form.Validators.hasValue(value)]);
      default:
        return Promise.resolve([name as Key]);
    }
  }

  function handleAddButtonClick(): void {
    setPending(true);
    Api.feedback
      .editFeedback(data ? data.id : id, {
        ...form.values
      })
      .then(() => {
        setPending(false);
        setIsOpenConfirmationModal(false);
        form.reset();
        data = undefined;
        onClickClose();
        onClickAdd();
      })
      .catch((error) => {
        setPending(false);
        console.log("Error: Update Feedback. " + error);
      });
  }

  function handleSubmitButtonClick(): void {
    Promise.all(Object.entries(form.values).map(validate)).then(
      (validations) => {
        const valid = validations.reduce((valid, [name, error]) => {
          return valid && !error;
        }, true);
        if (valid) {
          setIsOpenConfirmationModal(true);
        } else {
          validations.forEach(([name, error]) => {
            form.set(Form.target.ERROR, [name, error]);
          });
        }
      }
    );
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const clickCloseBtn = () => {
    setValues(undefined);
    form.reset();
    data = undefined;
    onClickClose();
  };

  const handleClose = () => {
    setOpen(false);
  };
  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  function onDenyInput(
    event: React.ChangeEvent<{}>
  ): void {
    event.preventDefault();
  }

  return (
    <Box mt={2} mb={2}>
      <Modal
        isOpen={isOpenConfirmationModal}
        positionButton="center"
        actions={[
          {
            label: "Cancel",
            variant: "outlined",
            handler: () => {
              setIsOpenConfirmationModal(false);
            },
          },
          {
            label: pending ? "Submitting..." : "Submit",
            handler: () => {
              handleAddButtonClick();
            },
            disabled: pending,
          },
        ]}
      >
        <Typography align="center" paragraph>
          Are you sure you want to update this Feedback?
        </Typography>
      </Modal>

      <Dialog
        open={isOpen}
        onClose={clickCloseBtn}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle id="form-dialog-title" onClose={clickCloseBtn}>
          Feedback: {data ? data.feedbackId : ""}
        </DialogTitle>
        <DialogContent>
          <Form>
            <Form.Textbox
              label="Sender"
              name="sentBy"
              //onChange={onDenyInput}            
              size={6}
              value={form.values.sentBy}            
              error={form.errors.sentBy}
            />
            <Form.Textbox
              label="Feedback Type"
              name="feedbackType"
              //onChange={onChange}
              size={6}
              value={form.values.feedbackType}            
              error={form.errors.feedbackType}
            />
            <Form.Textbox
              label="Business Unit"
              name="businessUnit"
              onChange={onChange}
              size={6}
              value={form.values.businessUnit}            
              error={form.errors.businessUnit}
            />
            <Form.Textbox
              label="Screenshot"
              name="screenshotURL"
              onChange={onChange}
              size={6}
              value={form.values.screenshotURL}            
              error={form.errors.screenshotURL}
            />
            <Form.Textbox
              label="Assigned To"
              name="assignedTo"
              onChange={onChange}
              size={6}
              value={form.values.assignedTo}            
              error={form.errors.assignedTo}
            />
             <Form.Dropdown
              label="Status"
              onChange={onChange}
              options={["New", "Closed"]}
              name="status"
              size={6}
              value={form.values.status}
              error={form.errors.status}
            />
            <Form.Textbox
              label="Subject"
              name="feedbackSubject"
              onChange={onChange}
              size={12}
              value={form.values.feedbackSubject}
              error={form.errors.feedbackSubject}
            />
            <Form.Textarea
              label="Resolution Details"
              name="resolutionDetails"
              onChange={onChange}
              size={12}
              maxLength={500}
              placeholder="Write details here. Max 500 characters"
              rows={5}
              rowsMax={5}
              value={form.values.resolutionDetails}
              error={form.errors.resolutionDetails}
            />
          </Form>
          <br />
          <CardWrapper title="Details">
            <Box p={3}>
              <Grid container direction="row">
                <Grid item xs={6}>
                <div dangerouslySetInnerHTML={{__html: form.values.details}} /> 
                </Grid>
                
              </Grid>
            </Box>
          </CardWrapper> 
        </DialogContent>
        <DialogActions>
          <Button onClick={clickCloseBtn} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmitButtonClick} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
